export default "__VITE_ASSET__Bv3Pq5T8__"